import { clsx } from 'clsx';
import { FC } from 'react';
import { TimeSlot, displaySecondsAsTime, useTimeSlots } from './ganttHelper';
import { useGanttService } from './GanttProvider';

interface GanttTimerBarProps {
  className?: string;
}

const GanttTimerCell: FC<{ slot: TimeSlot }> = ({ slot }) => {
  return (
    <div className="flex-1 relative" style={{ height: 50 }}>
      <div className="absolute w-full h-full flex items-center border-r box-border pl-2">
        {displaySecondsAsTime(slot.start)}
      </div>
    </div>
  );
};

export const GanttTimerBar: FC<GanttTimerBarProps> = ({ className }) => {
  const { minTime, maxTime } = useGanttService(state => ({ minTime: state.minShownTime, maxTime: state.maxShownTime }));

  const hourlySlots = useTimeSlots(minTime, maxTime, 60 * 60);

  return (
    <div className={clsx('flex w-full border-b pr-9', className)}>
      <div className="flex-1 flex">
        {hourlySlots.map(slot => (
          <GanttTimerCell slot={slot} key={slot.start} />
        ))}
      </div>
    </div>
  );
};
